"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerUserForQDInKesi = exports.registerUser = exports.PASSWORD_MIN_LENGTH = exports.FEATURE_QD_IN_KESI = exports.FEATURE_QD = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _DataStore = _interopRequireDefault(require("../../../KESI2/Stores/DataStore2"));

var _TournamentStateHelper = _interopRequireDefault(require("../../../helpers/TournamentStateHelper"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _UserManagementService = _interopRequireDefault(require("./services/UserManagementService"));

var _Feature = _interopRequireDefault(require("../../../utils/features/Feature"));

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _strings = require("./checks/strings");

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../../../utils/HttpRequest");

var _BuildConstants = require("../../../utils/BuildConstants");

var _DataStorePaths = require("../../../KESI2/Stores/DataStorePaths");

var _AppUtils = require("../../../utils/AppUtils");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _RestService = _interopRequireDefault(require("./services/RestService"));

var _CourseHelper = _interopRequireDefault(require("../../../helpers/CourseHelper"));

var REGISTER_QUIZZER_USER_URL = 'rest/api/v1/equeoqdUser/';
var FEATURE_QD = 'equeoqd';
exports.FEATURE_QD = FEATURE_QD;
var FEATURE_QD_IN_KESI = 'qdKesi';
exports.FEATURE_QD_IN_KESI = FEATURE_QD_IN_KESI;
var PASSWORD_MIN_LENGTH = 5;
/**
 * If password2 is given it must match password.
 * @returns {Promise<*>}
 */

exports.PASSWORD_MIN_LENGTH = PASSWORD_MIN_LENGTH;

var registerUser = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(code, nickName, password) {
    var email,
        password2,
        showLockedCallback,
        goToQuizHomeAfterwards,
        useAuthServer,
        features,
        mustAuthorize,
        userId,
        nickNameToUse,
        userNameToUse,
        checkActivationCodeReturnValue,
        userName,
        response,
        nickNameForQD,
        subject,
        _nickNameForQD,
        _subject,
        token,
        tokenPart,
        user,
        responseUser,
        _args2 = arguments;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            email = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : null;
            password2 = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : null;
            showLockedCallback = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : null;
            goToQuizHomeAfterwards = _args2.length > 6 && _args2[6] !== undefined ? _args2[6] : true;
            useAuthServer = _args2.length > 7 && _args2[7] !== undefined ? _args2[7] : false;

            if (!(password && password.length >= PASSWORD_MIN_LENGTH && (!password2 || password === password2))) {
              _context2.next = 97;
              break;
            }

            features = [];
            mustAuthorize = false;
            userId = null;
            nickNameToUse = nickName;
            _context2.next = 12;
            return _UserManagementService["default"].checkActivationCode(code, nickName, useAuthServer);

          case 12:
            checkActivationCodeReturnValue = _context2.sent;
            userName = checkActivationCodeReturnValue.username;

            if (!checkActivationCodeReturnValue.success) {
              _context2.next = 19;
              break;
            }

            if (typeof checkActivationCodeReturnValue.features === 'string') {
              features = [checkActivationCodeReturnValue.features];
            } else {
              features = checkActivationCodeReturnValue.features;
            }

            if (checkActivationCodeReturnValue.must_authorize === 1 || checkActivationCodeReturnValue.must_authorize === true) {
              mustAuthorize = true;
              userId = checkActivationCodeReturnValue.username;
            }

            _context2.next = 20;
            break;

          case 19:
            return _context2.abrupt("return", _promise["default"].reject(new Error((0, _strings.getString)('GROUP_CODE_WRONG'))));

          case 20:
            if (!mustAuthorize) {
              _context2.next = 34;
              break;
            }

            console.log('AAA going to revalidate');
            _context2.next = 24;
            return _UserManagementService["default"].revalidateUser(code, userName, password, nickName, useAuthServer);

          case 24:
            response = _context2.sent;

            if (response.user && response.user.nickname) {
              nickNameToUse = response.user.nickname;
            }

            if (!(response.user && response.user.additionalData && response.user.additionalData.subjects && response.user.additionalData.subjects.length > 0)) {
              _context2.next = 32;
              break;
            }

            nickNameForQD = response.user.additionalData.nickName;
            subject = response.user.additionalData.subjects[0];

            if (!(_config["default"].useDrupalContent && nickNameForQD && subject)) {
              _context2.next = 32;
              break;
            }

            _context2.next = 32;
            return registerUserForQDInKesi(nickNameForQD);

          case 32:
            _context2.next = 49;
            break;

          case 34:
            console.log('+++AAA going to register');
            _context2.next = 37;
            return _UserManagementService["default"].registerUser(code, nickName, password, useAuthServer, email);

          case 37:
            response = _context2.sent;
            console.log('+++ response', response);
            userId = response.user.userid;
            userNameToUse = response.user.username;

            if (response.user && response.user.nickname) {
              nickNameToUse = response.user.nickname;
            }

            if (!(response.user && response.user.additionalData && response.user.additionalData.subjects && response.user.additionalData.subjects.length > 0)) {
              _context2.next = 49;
              break;
            }

            _nickNameForQD = response.user.additionalData.nickName;
            _subject = response.user.additionalData.subjects[0];
            console.log('+++ useDrupalContent ', _config["default"].useDrupalContent);

            if (!(_config["default"].useDrupalContent && _nickNameForQD && _subject)) {
              _context2.next = 49;
              break;
            }

            _context2.next = 49;
            return registerUserForQDInKesi(_nickNameForQD);

          case 49:
            console.log('AAA done revalidate / register', features);

            if (showLockedCallback) {
              showLockedCallback();
            }

            if (!_config["default"].useDrupalContent) {
              _context2.next = 58;
              break;
            }

            _context2.next = 54;
            return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

          case 54:
            tokenPart = _context2.sent;
            token = "Bearer ".concat(tokenPart);
            _context2.next = 59;
            break;

          case 58:
            token = "Basic ".concat(window.btoa("".concat(userId, ":").concat(password)));

          case 59:
            _context2.next = 61;
            return (0, _TimeoutHelper.timeout)(300);

          case 61:
            features.forEach( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(featureName) {
                var feature;
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (featureName === FEATURE_QD) {
                          feature = new _Feature["default"](featureName, code, _config["default"].useDrupalContent ? userNameToUse : userId, password, {
                            nickName: nickNameToUse,
                            email: email,
                            _auth: token
                          });
                        } else {
                          feature = new _Feature["default"](featureName, code);
                        }

                        _context.next = 3;
                        return _FeatureManager["default"].removeFeature(featureName, goToQuizHomeAfterwards);

                      case 3:
                        _context.next = 5;
                        return _EquizzerActions["default"].removeActivatedFeature(featureName);

                      case 5:
                        _context.next = 7;
                        return _FeatureManager["default"].saveFeature(feature);

                      case 7:
                        _context.next = 9;
                        return _EquizzerActions["default"].addActivatedFeature(featureName);

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }()); // Save User to datastore and add feature 'equeoQD'

            user = {
              id: _config["default"].useDrupalContent ? userNameToUse : userId,
              password: password,
              nickName: nickNameToUse,
              activatedFeatures: features,
              activationCode: code,
              _auth: token
            };
            _context2.next = 65;
            return _DataStore["default"].setSingleData(_DataStorePaths.DATA_STORE_PATHS.QD_USER_AUTH, user);

          case 65:
            _TournamentStateHelper["default"].instance();

            _context2.next = 68;
            return _TournamentStateHelper["default"].setupInitialState();

          case 68:
            _context2.next = 70;
            return _RestService["default"].getUser([_config["default"].useDrupalContent ? userNameToUse : userId], token);

          case 70:
            responseUser = _context2.sent;
            console.log('revalidateUser', responseUser);

            if (!(responseUser.subjects && responseUser.subjects.length > 0)) {
              _context2.next = 77;
              break;
            }

            _context2.next = 75;
            return _EquizzerActions["default"].setUserSubjects(responseUser.subjects);

          case 75:
            _context2.next = 94;
            break;

          case 77:
            _context2.t0 = goToQuizHomeAfterwards;

            if (!_context2.t0) {
              _context2.next = 82;
              break;
            }

            _context2.next = 81;
            return _FeatureManager["default"].isChapterActivated('equeoqd_game_v2');

          case 81:
            _context2.t0 = _context2.sent;

          case 82:
            if (!_context2.t0) {
              _context2.next = 89;
              break;
            }

            _context2.next = 85;
            return (0, _TimeoutHelper.timeout)(500);

          case 85:
            _NavigationManager["default"].goToQuizHome();

            (0, _AppUtils.setMenuOpen)(false);
            _context2.next = 94;
            break;

          case 89:
            if (!goToQuizHomeAfterwards) {
              _context2.next = 94;
              break;
            }

            _context2.next = 92;
            return (0, _TimeoutHelper.timeout)(500);

          case 92:
            _NavigationManager["default"].goToQuizTraining();

            (0, _AppUtils.setMenuOpen)(false);

          case 94:
            return _context2.abrupt("return", null);

          case 97:
            if (!(password.length < PASSWORD_MIN_LENGTH && password)) {
              _context2.next = 101;
              break;
            }

            return _context2.abrupt("return", _promise["default"].reject(new Error((0, _strings.getString)('PASSWORD_SHORT'))));

          case 101:
            if (!(password !== password2)) {
              _context2.next = 105;
              break;
            }

            return _context2.abrupt("return", _promise["default"].reject(new Error((0, _strings.getString)('PASSWORD_MATCH_ERROR'))));

          case 105:
            return _context2.abrupt("return", _promise["default"].reject(new Error((0, _strings.getString)('E_PASSWORDS_EMPTY'))));

          case 106:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function registerUser(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
/**
 *
 * @returns {Promise<*>}
 */


exports.registerUser = registerUser;

var registerUserForQDInKesi = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(nickName) {
    var token, data, response, message, subjects;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            console.log('going to check qd activation code 3', nickName);
            _context3.next = 3;
            return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

          case 3:
            token = _context3.sent;
            console.log('going to check qd activation code 4', token);
            data = {
              nickname: nickName
            };
            _context3.next = 8;
            return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.QUIZZER_HOST, "/").concat(REGISTER_QUIZZER_USER_URL), data, null, false, 60000, 10, 'Bearer ' + token);

          case 8:
            response = _context3.sent;
            console.log('going to check qd activation code 5', response);
            message = null;

            if (!response) {
              _context3.next = 28;
              break;
            }

            if (!(response.status && response.status !== 200)) {
              _context3.next = 16;
              break;
            }

            message = ' register answers with status ' + response.status + '. ' + (response.data && response.data.errors ? response.data.errors.join(', ') : '');
            _context3.next = 26;
            break;

          case 16:
            if (!(response.data && response.data.errors)) {
              _context3.next = 20;
              break;
            }

            message = response.data.errors.join(', ');
            _context3.next = 26;
            break;

          case 20:
            if (!(response.data && response.data.data)) {
              _context3.next = 26;
              break;
            }

            console.log('response.data.data', response.data.data);

            if (!(response.data.data.playgroups && response.data.data.playgroups.length > 0)) {
              _context3.next = 25;
              break;
            }

            _context3.next = 25;
            return _DataStore["default"].setSingleData(_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_ID, response.data.data.playgroups[0].id);

          case 25:
            if (response.data.data.subjects) {
              subjects = response.data.data.subjects;
              console.log('going to check qd activation code 6', subjects);

              _DataStore["default"].setSingleData(_DataStorePaths.DATA_STORE_PATHS.QD_USER_SUBJECTS, subjects);

              if (subjects.length > 0) {
                _DataStore["default"].setSingleData(_DataStorePaths.DATA_STORE_PATHS.QD_SUBJECT_ID, subjects[0].id);
              }
            }

          case 26:
            _context3.next = 29;
            break;

          case 28:
            message = 'no response';

          case 29:
            return _context3.abrupt("return", message ? new Error(message) : null);

          case 30:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function registerUserForQDInKesi(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

exports.registerUserForQDInKesi = registerUserForQDInKesi;